import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cc50e2da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gswp mb-6" }
const _hoisted_2 = { class: "gswp-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_GamePicker = _resolveComponent("GamePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideSelect)
      ? (_openBlock(), _createBlock(_component_SelectInput, {
          key: 0,
          input: _ctx.input,
          mode: 'relationships',
          options: _ctx.options,
          "model-value": _ctx.modelValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
          disabled: _ctx.disabled
        }, null, 8, ["input", "options", "model-value", "disabled"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "gswp-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = true))
      }, "Browse…")
    ]),
    _createVNode(_component_GamePicker, {
      open: _ctx.open,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => (_ctx.open = $event)),
      mode: _ctx.isMultiple ? 'multiple' : 'single',
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
      options: _ctx.options
    }, null, 8, ["open", "mode", "model-value", "options"])
  ]))
}